import { EventType } from "@ac-expo/api-types";
import { isValidPhoneNumber } from "react-phone-number-input";
import { z } from "zod";

export const updateContactPhoneSchema = z.object({
  phone: z
    .string()
    .refine((phoneNumber) => isValidPhoneNumber(phoneNumber, "FR"), {
      message: "Téléphone invalide",
    }),
});

export const getDefaultUpdateExhibitorContactPhoneValues = (
  event: EventType
) => {
  return {
    phone: event.exhibitorContactPhone || "",
  };
};

export const getDefaultUpdateContactPhoneValues = (event: EventType) => {
  return {
    phone: event.contactPhone || "",
  };
};

export type UpdateContactPhoneForm = z.infer<typeof updateContactPhoneSchema>;
